/**
 * Entry point for the map, served at /mapa/v2 while it reaches parity with
 * frontend/legacy/index.html, then at / and /valencia.
 *
 * Deliberately thin, like the funnel's: everything lives in map/, and the parts
 * worth testing on their own — the filters, the classification, the search
 * matching, the extent — are plain modules under map/lib/ rather than logic
 * trapped inside a component or, as before, inside a 1 858-line <script>.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { MapPage } from "./MapPage";
import "maplibre-gl/dist/maplibre-gl.css";
import "./map.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from mapa.html");

createRoot(root).render(
  <StrictMode>
    <MapPage />
  </StrictMode>,
);
